
            const data = {"name":"glyph/12/triangle-down-black","data":{"width":"12","height":"12","viewBox":"0 0 16 16","data":"<path pid=\"0\" _fill=\"#000\" d=\"m3 5 5 6 5-6z\" class=\"nc-icon-wrapper\"/>","originalColors":[{"type":"fill","color":"#000"}],"stopColors":[]}}
        
                    module.exports = data
                    